import { useEffect, useState } from "react";
import { IVerificaitonAccountsFormProps } from "../../interfaces/account/signup";
import { toast } from "react-toastify";
import { IError } from "../../interfaces/user/errors";
import { AppDispatch } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetAuth } from "../../stores/auth-slice";
import { verificationAccount } from "../../data-access/apis/authentication/auth";

const verificationAccountFormProps: IVerificaitonAccountsFormProps = {
  contact: '',
  otp: '',
  phone: '',
};

export const VerificationAccountHelper = () => {
  const [values, setValues] = useState<IVerificaitonAccountsFormProps>(verificationAccountFormProps);
  const [formErrors, setFormErrors] = useState<IError[]>([]);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const account = useSelector((state: any) => state.auth);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const validateContactInfo = (contact: string): IError | null => {
    const isEmailValid = /\S+@\S+\.\S+/.test(contact);
    const isPhoneValid = /^[0-9]{10}$/.test(contact);

    if (contact.trim() === '') {
      return { field: 'contact', message: 'Please provide either email, username, or phone number.' };
    } else if (isEmailValid || isPhoneValid) {
      return null;
    } else {
      return { field: 'contact', message: 'Please enter a valid email address or phone number.' };
    }
  };

  const validateOtp = (otp: string): IError | null => {
    if (otp.trim() === '') {
      return { field: 'otp', message: 'Please enter an OTP.' };
    } else if (!/^\d+$/.test(otp)) {
      return { field: 'otp', message: 'OTP must be numeric.' };
    }
    return null;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const errors: IError[] = [];
    const contactInfoError = validateContactInfo(values.contact || '');
    if (contactInfoError) {
      errors.push(contactInfoError);
    }

    const otpError = validateOtp(values.otp);
    if (otpError) {
      errors.push(otpError);
    }

    setFormErrors(errors);

    if (errors.length > 0) {
      errors.forEach((error) => {
        toast.error(error.message, {
          position: "bottom-right",
          autoClose: 3000,
        });
      });
      return;
    }

    setIsProcessing(true);

    let payload: { email?: string; username?: string; phone?: string; otp: string } = {
      otp: values.otp,
    };

    if (values.contact && /\S+@\S+\.\S+/.test(values.contact)) {
      payload.email = values.contact;
    } else if (values.contact && /^[0-9]{10}$/.test(values.contact)) {
      payload.phone = values.contact;
    }

    try {
      if (errors.length === 0) {
        await dispatch(verificationAccount(payload)).unwrap();
      }
    } catch (error: any) {
    } finally {
      setIsProcessing(false);
      setValues(verificationAccountFormProps);
    }
  };

  useEffect(() => {
    if (account.statusCode === 200) {
      setIsProcessing(false);
      setValues(verificationAccountFormProps);
      navigate('/auth/create-new-password');
      dispatch(resetAuth());
    }
  }, [account.statusCode, navigate, dispatch])

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  return {
    values,
    formErrors,
    handleChange,
    handleSubmit,
    isProcessing,
  };
};
